import { Component, OnInit, inject, computed, signal, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { UserProfileDisplayService } from '../../services/user-profile-display.service';

@Component({
    selector: 'app-header',
    imports: [CommonModule, RouterModule],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    @Output() toggleSidebar = new EventEmitter<void>();

    private authService = inject(AuthService);
    private profileUi = inject(UserProfileDisplayService);

    currentDate: string = '';
    pageTitle: string = 'Dashboard Overview';
    isLoggingOut = signal(false);
    showLogoutConfirm = signal(false);
    currentTime = signal(new Date());
    private timerHandle: any;

    // Get current user from auth service
    currentUser = computed(() => this.authService.currentUser());
    isAuthenticated = computed(() => this.authService.isAuthenticated());

    displayName = computed(() => this.profileUi.displayName(this.authService.currentUser()));
    designation = computed(() => this.profileUi.designation(this.authService.currentUser()));
    roleBadge = computed(() => this.profileUi.roleBadge(this.authService.currentUser()));
    avatarUrl = computed(() => this.profileUi.avatarUrl(this.authService.currentUser()));
    avatarInitial = computed(() => this.profileUi.avatarInitial(this.authService.currentUser()));

    ngOnInit(): void {
        this.updateDate();

        // Debug: Log auth state changes
        this.authService.authState$.subscribe(user => {
            console.log('Header: Auth state changed, user:', user?.email);
        });

        // Update real-time clock every minute
        this.timerHandle = setInterval(() => {
            this.currentTime.set(new Date());
        }, 60000);
    }

    updateDate(): void {
        const now = new Date();
        const options: Intl.DateTimeFormatOptions = {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        };
        this.currentDate = now.toLocaleDateString('en-IN', options);
    }

    onToggleSidebar(): void {
        this.toggleSidebar.emit();
    }

    confirmLogout(): void {
        this.showLogoutConfirm.set(true);
    }

    cancelLogout(): void {
        this.showLogoutConfirm.set(false);
    }

    async logout(): Promise<void> {
        this.isLoggingOut.set(true);
        this.showLogoutConfirm.set(false);

        try {
            console.log('Header: Initiating logout...');
            await this.authService.logout();
            console.log('Header: Logout successful!');
        } catch (error) {
            console.error('Logout error:', error);
            this.isLoggingOut.set(false);
            // Still attempt navigation in case of error
            window.location.href = '/login';
        }
    }
}
